import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { activeState } from "../../theme/activeState";
import { transition } from "../../utils/transition";
import { disabledState } from "../../theme/disabledState";

export const containerStyle = recipe({
  base: {
    position: "relative",
    display: "flex",
  },
  variants: {
    size: {
      default: {
        width: rem(48),
        height: rem(48),
      },
    },
    variant: {
      full: {
        width: "100%",
        flexGrow: 1,
        alignItems: "flex-start",
        selectors: {
          "&:before": {
            display: "none",
          },
        },
      },
      default: {},
      compact: {},
    },
    active: {
      true: {
        selectors: {
          "&:before": {
            content: '""',
            position: "absolute",
            top: rem(-1),
            left: rem(-1),
            zIndex: 0,
            width: `calc(100% + ${rem(2)})`,
            height: `calc(100% + ${rem(2)})`,
            background: `linear-gradient(103.85deg, ${theme.colors.gradientA} -0.39%, ${theme.colors.gradientB} 23.95%, ${theme.colors.gradientC} 47.38%, ${theme.colors.gradientD} 72.64%)`,
            borderRadius: "50%",
            opacity: 1,
            transition: transition("opacity"),
          },
        },
      },
    },
  },
  defaultVariants: {
    size: "default",
  },
});

export const itemStyle = recipe({
  base: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
    transition: transition(
      "color",
      "outline",
      "background-color",
      "border-color",
      "border-radius",
      {
        property: "transform",
        duration: theme.transition.duration.xs,
      },
    ),
    userSelect: "none",
    position: "relative",
    selectors: {
      "&:not([disabled]):not([aria-disabled])": {
        cursor: "pointer",
      },
      "&:not([disabled]):not([aria-disabled]):active": {
        ...activeState,
      },
      "&[disabled], &[aria-disabled]": {
        ...disabledState,
      },
    },
  },
  variants: {
    appearance: {
      rounded: {
        borderRadius: theme.borderRadiuses.s,
      },
      round: {
        borderRadius: "50%",
      },
    },
    variant: {
      default: {
        background: "transparent",
        color: theme.colors.onBackground,
        selectors: {
          "&:not([disabled]):not([aria-disabled]):hover": {
            background: theme.colors.primary,
            borderColor: theme.colors.primary,
            color: theme.colors.onPrimary,
          },
        },
      },
      full: {
        width: "100%",
        flexGrow: 1,
        gap: theme.spacings.m,
        justifyContent: "flex-start",
        padding: `0 ${theme.spacings.s} 0 ${theme.spacings.s}`,
      },
    },
    active: {
      true: {
        background: theme.colors.background,
      },
    },
  },
  defaultVariants: {
    appearance: "round",
    variant: "default",
  },
});

export const progressStyle = style({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
});

export const badgeStyle = style({
  transform: `translate(${rem(2)}, 0)`,
});
